import { X } from 'lucide-react';
import { getTextColorHex } from '../utils/color-contrast';

interface FilterChipProps {
  label: string;
  selected?: boolean;
  onToggle?: () => void;
  onRemove?: () => void;
  disabled?: boolean;
}

export function FilterChip({ 
  label, 
  selected = false, 
  onToggle, 
  onRemove,
  disabled = false 
}: FilterChipProps) {
  const handleClick = () => {
    if (!disabled && onToggle) {
      onToggle();
    }
  };

  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!disabled && onRemove) {
      onRemove();
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-all active:scale-95 disabled:cursor-not-allowed disabled:opacity-50"
      style={{
        backgroundColor: selected ? '#3b0b86' : '#f5f5f5',
        color: selected ? getTextColorHex('#3b0b86') : '#1a1a1a',
        fontFamily: 'var(--font-primary)',
        border: selected ? 'none' : '1px solid rgba(0, 0, 0, 0.1)',
      }}
    >
      <span>{label}</span>
      {selected && onRemove && (
        <X
          className="h-4 w-4 cursor-pointer hover:opacity-80"
          onClick={handleRemove}
        />
      )}
    </button>
  );
}